import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Link from '../../../Link';
import { MenuChild as MenuChildProps } from '../../../../interfaces/common';

const MenuChild: React.FC<MenuChildProps> = ({ text, redirectsTo }) => {
  const navigate = useNavigate();
  const currentRoute = window.location.pathname;
  const active = redirectsTo && currentRoute.includes(redirectsTo);

  const handleMenuChildClick = useCallback(() => {
    redirectsTo && navigate(redirectsTo);
  }, [navigate, redirectsTo]);

  return (
    <li key={text} className={`menu-item ${active ? 'active' : ''}`}>
      <Link className="cursor-pointer menu-link" text={text} onClick={handleMenuChildClick} />
    </li>
  );
};

export default MenuChild;
